import { render } from "./ProjectInfoComponent.vue?vue&type=template&id=30a2c77c&scoped=true&ts=true"
import script from "./ProjectInfoComponent.vue?vue&type=script&lang=ts"
export * from "./ProjectInfoComponent.vue?vue&type=script&lang=ts"

import "./ProjectInfoComponent.vue?vue&type=style&index=0&id=30a2c77c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a2c77c"]])

export default __exports__